export const FILTER_KEY = 'filters'
export const ORDERING_KEY = 'ordering'
